
import { SubDomain } from "../SubDomain.js";
import InvoiceItem from "./InvoiceItem";

export default class InvoiceItemsDomain extends SubDomain {
  
  constructor(domain, storage) {
    super(domain, InvoiceItem.MODEL_NAME);
    this._storage = storage;
  }
  
  list() {
    return this._storage.list;
  }
  
  findById(objId) {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      if (super.toId(item) == objId) {
        return new InvoiceItem(this.domain, item);
      }
    }

    return new InvoiceItem(this.domain);
  }
  
}